import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input, Output, EventEmitter } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { PartnerNamesEnum } from '../shared';

@Component({
    selector: 'app-header',
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {
    @Input() headerTitle = "Cannabistherapie Kostenübernahmeantrag";
    @Input() showNav: boolean = true;

    @Input() stepper: boolean = true;
    @Output() returnEvent = new EventEmitter();

    @Input() partnerName: string = "";
    PartnerNamesEnum = PartnerNamesEnum;

    get isPartnerPage() {
        return this.partnerName && this.partnerName.length;
    }

    constructor(private http: HttpClient,
        private cd: ChangeDetectorRef) { }

    ngOnInit(): void {
    }

    onIconClick(type) {
        this.returnEvent.emit({ type: type });
    }

    toggleStepper() {
        this.stepper = !this.stepper;
        this.returnEvent.emit({ type: 'stepper', value: this.stepper });
    }
}
